import { render } from "./Seen.vue?vue&type=template&id=10a2ac8e&scoped=true"
import script from "./Seen.vue?vue&type=script&lang=js"
export * from "./Seen.vue?vue&type=script&lang=js"

import "./Seen.vue?vue&type=style&index=0&id=10a2ac8e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a2ac8e"]])

export default __exports__